import { throwError } from '../utils/throwError.js';
export function parseError(src, type, cause) {
    return throwError('parse', src, type, cause);
}
//# sourceMappingURL=parseError.js.map